import { is1DFOCAQExperimentEnabled } from 'feature-flags';
import { GETTING_STARTED_PAGE_LEARN_BY_DOING, QUEUES } from '../constants';

export const shouldShowLearnByDoingBanner = (isProjectAdmin: boolean, referrer: string = ''): boolean =>
    isProjectAdmin &&
    (referrer === GETTING_STARTED_PAGE_LEARN_BY_DOING || referrer === QUEUES) &&
    is1DFOCAQExperimentEnabled() === 'variation';
